import { Injectable } from '@angular/core';

import * as fromRoot from '@app/reducers';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class AdminGuard  {

  constructor(private store$: Store<fromRoot.State>) { }

  canActivate(): Observable<boolean> {
    return this.store$.select(fromRoot.getIsAdministrator);
  }
}
